import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import Header from "../../src/Components/Header";
import Loader from "../../src/Components/Common/Loader";
import LoaderForSearch from "../../src/Components/Common/LoaderForSearch";
import SingleSignOnSideBar from "../Components/SingleSignOnSideBar";
import { CommonDate, toDateMax } from "../CommonMethhods/DateFunction";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { CALLSVICES } from "../Configuration/Telecaller_URl";
import { splitDate, splitDateNew } from "../CommonMethhods/CommonMethods";
import { async } from "q";
import { toast } from "react-toastify";
// import JSZip from "jszip";

function RecordingReport() {
  const [loader, setLoader] = useState(false);
  const [callRecordData, setCallRecordData] = useState([]);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [page, setPage] = useState(1);
  const [serverError, setServerError] = useState("");
  const [count, setCount] = useState();
  const [error, setError] = useState("");
  const [url, setUrl] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [sortData, setSortData] = useState("ascending");
  const [checkArray, setCheckArray] = useState([]);

  const searchIp = useRef("");
  const todatRef = useRef("");
  const fromDateRef = useRef("");
  const schema = yup.object().shape({
    search: yup.string(),
    // fromDate: yup.string().required("This is required")
    //   .test("valid date", "Kindly select Proper Date Range", (value) => {
    //     return new Date(value).getTime() >= new Date("2018-01-01").getTime()
    //   }),
    // toDate: yup.string().required("This is required"),
    fromDate: yup
      .string()
      .required("Please enter from date")
      .test("is P", "Date should not be greater than current date", (value) => {
        return new Date(value).getTime() < new Date().getTime();
      })
      .test("is P", "From date should not be graeter than to date", (value) => {
        if (getAdminData("toDate") !== "") {
          return (
            new Date(value).getTime() <=
            new Date(getAdminData("toDate")).getTime()
          );
        } else {
          return true;
        }
      }),
    toDate: yup
      .string()
      .required("Please enter to date")
      .test("is P", "Date should not be greater than current date", (value) => {
        return new Date(value).getTime() < new Date().getTime();
      })
      .test("is P", "To date should be graeter than from date", (value) => {
        if (getAdminData("fromDate") !== "") {
          return (
            new Date(value).getTime() >=
            new Date(getAdminData("fromDate")).getTime()
          );
        } else {
          return true;
        }
      }),
  });

  // const schema = yup.object().shape({
  //   search: yup.string(),
  //   fromDate: yup.string().required("This is required").test("valid date", "Below 2018 not allowed", (value) => {
  //     return new Date(value).getTime() >= new Date("2018-01-01").getTime();
  //   }).test("fromDate", "From date should be less than or equal to To date", function (value) {
  //     const toDate = this.parent.toDate;
  //     return new Date(value) <= new Date(toDate);
  //   }),
  //   toDate: yup.string().required("This is required"),
  // });

  const {
    handleSubmit,
    register: register,
    formState: { errors },
    reset: reset,
    getValues: getAdminData,
    trigger,
  } = useForm({ resolver: yupResolver(schema), mode: "onChange" });

  const onSubmitSorting = () => {
    if (sortData === "descending") {
      setSortData("ascending");
    } else {
      setSortData("descending");
    }
    // setSortData(e.target.value)
  };
  const CallRecordingDownloadReport = async (data, page, firstLoad = false) => {
    if (firstLoad) {
      setLoader(true);
    }
    try {
      const getRecordDetails = await axios.post(
        CALLSVICES.CallRecordingDownloadReport,
        {
          fromDate: data.fromDate,
          toDate: data.toDate,
          type: "grid",
          pageNo: page,
          pageSize: 10,
          search: data.search,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const res = getRecordDetails?.data?.Response;
      setCount(res?.TotalCount);
      if (res?.Data) {
        if (firstLoad) {
          setCallRecordData(res?.Data);
        } else {
          let allArr = [...callRecordData, ...res?.Data];
          dataSorting(sortData, allArr);

          // setCallRecordData((prev) => {
          //   return [...prev, ...res.Data];
          // });
        }
      } else {
        setCallRecordData([]);
        setError("No data Found");
      }
    } catch (error) {
      // setCallRecordData([]);
      // setError(error.message);
      if (error?.response?.data?.Status == "Failed") {
        setError(error?.response?.data?.Response);
        setCallRecordData([]);
      }
    } finally {
      setLoader(false);
      setScrollLoader(false);
    }
  };

  const handleScroll = () => {
    const a = document.querySelector("#call-recording-report");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      if (count <= 10 * page) {
        setScrollLoader(false);
        return;
      }
      setPage((prev) => prev + 1);
      setScrollLoader(true);
    }
  };
  useEffect(() => {
    let data = {
      search: getAdminData("search"),
      fromDate: getAdminData("fromDate"),
      toDate: getAdminData("toDate"),
    };
    if (page > 1) {
      CallRecordingDownloadReport(data, page, false);
    }
  }, [page]);
  useEffect(() => {
    let data = {
      search: getAdminData("search"),
      fromDate: getAdminData("fromDate"),
      toDate: getAdminData("toDate"),
    };
    CallRecordingDownloadReport(data, page, false);
  }, []);

  useEffect(() => {
    // if (selectedFiles.length !== 0) {
    //   downloadSelectedFiles()
    // }
  }, [selectedFiles]);

  const downloadSelectedFiles = async () => {
    const downloadPromises = selectedFiles.map(async (url) => {
      try {
        const response = await axios.get(
          url,
          { responseType: "blob" },
          { headers: { "Access-Control-Allow-Origin": "*" } }
        );
        const blob = new Blob([response.data]);
        // const fileName = url.split("?")[0].split("/")[4];
        let fileNameArray = new URL(url).pathname.split("/");
        let fileName = fileNameArray[fileNameArray.length - 1];

        // let subIndex = fileName.indexOf("?");
        // let SubFilename = fileName.substring(0, subIndex);

        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = downloadUrl;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(a);
      } catch (error) {
        console.error(`Error downloading ${url}:`, error);
      } finally {
        setSelectedFiles([]);
        // debugger
        const selectDownload = document.querySelectorAll(".downloadSelect");
        for (let item of selectDownload) {
          if (item.checked === true) {
            item.checked = false;
          }
        }
      }
    });

    await Promise.all(downloadPromises);
  };

  useEffect(() => {
    if (callRecordData.length !== 0) {
      setLoader(true);
      dataSorting(sortData, callRecordData);
      setLoader(false);
    }
  }, [sortData]);

  const dataSorting = (data, toSortArr) => {
    // setLoader(true)
    let sortNumAsc = [];
    if (data === "ascending") {
      sortNumAsc = [...toSortArr].sort(
        (a, b) =>
          new Date(a.CallRecordedDateTime).getTime() -
          new Date(b.CallRecordedDateTime).getTime()
      );

      // .reverse()
      // sort((a, b) => new Date(a.CallRecordedDateTime) - new Date(b.CallRecordedDateTime));
      setCallRecordData(sortNumAsc);
    } else if (data === "descending") {
      // sortNumAsc = [...callRecordData].reverse()
      sortNumAsc = [...toSortArr].sort(
        (a, b) =>
          new Date(b.CallRecordedDateTime).getTime() -
          new Date(a.CallRecordedDateTime).getTime()
      );

      // .sort((a, b) => new Date(b.CallRecordedDateTime) - new Date(a.CallRecordedDateTime));
      setCallRecordData(sortNumAsc);
    }
    // setLoader(false)
  };

  const handleDownloadDocument = async (url) => {
    // window.open(data);
    try {
      const response = await axios.get(
        url,
        { responseType: "blob" },
        { headers: { "Access-Control-Allow-Origin": "*" } }
      );
      const blob = new Blob([response.data]);
      // const fileName = url.substring(url.lastIndexOf('/') + 1);
      // let subIndex = fileName.indexOf("?");
      // let SubFilename = fileName.substring(0, subIndex)
      let fileNameArray = new URL(url).pathname.split("/");
      let fileName = fileNameArray[fileNameArray.length - 1];
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(a);
    } catch (error) {
      console.error(`Error downloading ${url}:`, error);
    }
  };

  const downloadMultiple = (checked = true) => {
    const selectDownload = document.querySelectorAll(".downloadSelect");

    let selectArray = [];
    for (let item of selectDownload) {
      if (checked) {
        if (item.checked === true) {
          selectArray.push(item.value);
        }
      } else {
        selectArray.push(item.value);
      }
    }
    // toast.error("Please sclect the box")
    setSelectedFiles(selectArray);
    if (selectArray.length === 0) {
      toast.error("Please select atleast one record");
    }
  };

  const handleOnClick = (data) => {
    setPage(1);
    setSortData("ascending");
    CallRecordingDownloadReport(data, 1, true);

    // let fromdate = data.fromDate;
    // let todate = data.toDate;
    // let fromDateObj = new Date(fromdate);
    // let toDateObj = new Date(todate);
    // let currentDate = new Date();

    // if (fromDateObj >= new Date('2018-01-01') && fromDateObj <= currentDate) {
    //   if (fromDateObj.getTime() === toDateObj.getTime() || fromDateObj < toDateObj) {
    //     setPage(1);
    //     setSortData("ascending")
    //     CallRecordingDownloadReport(data, 1, true);
    //   } else {
    //     toast.error("Please select a valid date range. 'From date' should be less than or equal to 'To date'.");
    //     setCallRecordData([]);
    //   }
    // } else {
    //   toast.error("Please select a valid date range (from 2018 to current date).");
    //   setCallRecordData([]);
    // }
  };

  // const dateChange = (e) => {
  //   if (e.target.value > "2018-01-01") {
  //     setCallRecordData([])
  //   }
  // }
  const oneWeekFromNow = new Date();
  oneWeekFromNow.setDate(oneWeekFromNow.getDate() - 7);
  const defaultDate = oneWeekFromNow.toISOString().split("T")[0];

  const selectCheckBox = (e) => {
    downloadMultiple();
  };

  return (
    <>
      <Header portal={"TELECALLER"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="telecallerDash">
        <div className="card-box revenue-report download-r">
          <form onSubmit={handleSubmit(handleOnClick)}>
            <div className="row input-field-wrapper">
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label className="form-label">Search</label>
                  <div className="">
                    <input
                      type="text"
                      name="search-text"
                      id="SearchInput_RevenueR"
                      className="form-control"
                      placeholder="Search here..."
                      autoComplete="off"
                      ref={searchIp}
                      {...register("search")}
                      onInput={(e) => {
                        const start = e.target.selectionStart;
                        const end = e.target.selectionEnd;

                        let input = e.target.value;
                        input = input
                            .toUpperCase()
                            .replace(/[^A-Z0-9\s]/g, "")
                            .replace(/\s+/g, " ")
                            .trimStart()
                            .slice(0, 100);

                        e.target.value = input;
                        e.target.setSelectionRange(start, end);                        
                    }}
                    />
                  </div>
                </div>
              </div>

              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    From Date:
                  </label>
                  <div>
                    <input
                      type="date"
                      className={`datepicker form-control ${
                        errors?.fromDate ? "is-invalid" : ""
                      }`}
                      placeholder=""
                      ref={fromDateRef}
                      max={CommonDate.getPreviousDay}
                      {...register("fromDate", {
                        onChange: () => {
                          if (getAdminData("toDate") !== "") {
                            trigger("toDate");
                          }
                        },
                      })}
                      defaultValue={defaultDate}
                    />

                    <div className="invalid-feedback">
                      {errors.fromDate?.message}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-sm-3 col-6">
                <div className="form-group">
                  <label htmlFor="" className="form-label">
                    To Date:
                  </label>
                  <div>
                    <input
                      type="date"
                      className={`datepicker form-control ${
                        errors?.toDate ? "is-invalid" : ""
                      }`}
                      placeholder=""
                      max={CommonDate.toDateMax}
                      ref={todatRef}
                      {...register("toDate", {
                        onChange: () => {
                          if (getAdminData("fromDate") !== "") {
                            trigger("fromDate");
                          }
                        },
                      })}
                      defaultValue={toDateMax(todatRef)}
                    />
                    <div className="invalid-feedback">
                      {errors.toDate?.message}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-center search-btn-wrapper">
              <button value="grid" className="send-message">
                SUBMIT
              </button>
            </div>
          </form>

          <div className="for-grid-section">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : callRecordData.length > 0 ? (
              <>
                <div className="table-responsive scroll-table dealer-table">
                  <button
                    value="grid"
                    className="send-message"
                    onClick={() => downloadSelectedFiles()}
                    disabled={selectedFiles.length === 0}
                  >
                    DOWNLOAD
                  </button>
                  {/* <button value="grid" className="send-message" style={{ marginLeft: "20px", marginBottom: "10px" }} onClick={() => downloadMultiple(false)}>
                    DOWNLOAD ALL
                  </button> */}
                  <table className="table last-column">
                    <thead>
                      <tr>
                        <th scope="col" className="text-center">
                          Select
                        </th>
                        <th scope="col" className="text-center">
                          AP Code
                        </th>
                        <th scope="col" className="text-center">
                          AP Mobile
                        </th>
                        <th scope="col" className="text-center">
                          Client Code
                        </th>
                        <th scope="col">Client Mobile</th>
                        {/* <th> */}
                        {/* <label for="dateDropdown">Sort Dates:</label>
                          <select id="dateDropdown" {...registersorting("dropdownSorting")} onChange={onSubmitSorting}>
                            <option value="ascending">Ascending</option>
                            <option value="descending">Descending</option>
                          </select> */}
                        <th scope="col">
                          <div>Call Recorded Date & Time</div>
                          <div onClick={onSubmitSorting}>
                            <svg
                              height="14px"
                              width="14px"
                              version="1.1"
                              id="Layer_1"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                            >
                              <g>
                                <path
                                  style={{
                                    fill:
                                      sortData === "ascending"
                                        ? "#ccc"
                                        : "#3D6DEB",
                                  }}
                                  d="M123.177,505.18c0.545,0.543,1.117,1.058,1.713,1.547c0.264,0.219,0.546,0.408,0.818,0.613
		c0.334,0.251,0.661,0.51,1.008,0.742c0.33,0.222,0.675,0.413,1.013,0.616c0.312,0.186,0.616,0.383,0.937,0.554
		c0.349,0.186,0.704,0.343,1.06,0.51c0.334,0.158,0.662,0.324,1.004,0.467c0.346,0.143,0.697,0.258,1.049,0.383
		c0.366,0.132,0.728,0.272,1.1,0.385c0.352,0.105,0.706,0.185,1.061,0.273c0.382,0.098,0.76,0.203,1.15,0.281
		c0.408,0.081,0.816,0.129,1.227,0.188c0.341,0.048,0.678,0.113,1.022,0.147c0.765,0.074,1.531,0.115,2.298,0.115
		s1.533-0.04,2.296-0.116c0.346-0.034,0.681-0.099,1.022-0.147c0.411-0.059,0.819-0.107,1.227-0.188
		c0.389-0.078,0.768-0.185,1.15-0.281c0.355-0.088,0.709-0.166,1.061-0.273c0.372-0.113,0.734-0.253,1.1-0.385
		c0.352-0.126,0.703-0.24,1.049-0.383c0.343-0.143,0.672-0.309,1.004-0.467c0.355-0.166,0.711-0.324,1.06-0.51
		c0.321-0.172,0.625-0.368,0.937-0.554c0.34-0.203,0.683-0.394,1.013-0.616c0.349-0.233,0.676-0.492,1.008-0.742
		c0.273-0.205,0.554-0.394,0.818-0.613c0.596-0.489,1.168-1.004,1.713-1.547l116.359-116.361c9.089-9.087,9.089-23.824,0-32.912
		c-9.087-9.089-23.824-9.089-32.912,0l-76.632,76.637V23.273C162.91,10.42,152.49,0,139.637,0s-23.273,10.42-23.273,23.273v409.27
		l-76.636-76.634c-9.087-9.089-23.824-9.089-32.912,0c-9.089,9.087-9.089,23.823,0,32.912L123.177,505.18z"
                                />
                                <path
                                  style={{
                                    fill:
                                      sortData === "descending"
                                        ? "#ccc"
                                        : "#3D6DEB",
                                  }}
                                  d="M387.113,5.274c-0.261-0.216-0.538-0.402-0.807-0.604c-0.34-0.254-0.67-0.515-1.021-0.751
		c-0.327-0.219-0.667-0.408-1.002-0.608c-0.316-0.189-0.625-0.388-0.953-0.562c-0.343-0.183-0.694-0.338-1.046-0.504
		c-0.338-0.16-0.67-0.329-1.016-0.472c-0.341-0.141-0.689-0.256-1.035-0.379c-0.369-0.133-0.737-0.276-1.116-0.389
		c-0.346-0.104-0.694-0.18-1.043-0.268c-0.388-0.098-0.771-0.206-1.167-0.285c-0.399-0.079-0.802-0.126-1.202-0.183
		c-0.349-0.051-0.694-0.116-1.049-0.152c-0.74-0.073-1.482-0.11-2.225-0.112C372.409,0.003,372.389,0,372.364,0
		s-0.045,0.003-0.07,0.003c-0.743,0.003-1.485,0.039-2.225,0.112c-0.355,0.036-0.7,0.101-1.049,0.152
		c-0.402,0.057-0.805,0.104-1.202,0.183c-0.396,0.078-0.779,0.186-1.167,0.285c-0.349,0.088-0.697,0.164-1.043,0.268
		c-0.379,0.115-0.745,0.256-1.116,0.389c-0.346,0.124-0.694,0.237-1.035,0.379c-0.348,0.143-0.68,0.312-1.016,0.472
		c-0.352,0.164-0.703,0.32-1.046,0.504c-0.327,0.174-0.636,0.372-0.953,0.562c-0.335,0.2-0.675,0.389-1.002,0.608
		c-0.352,0.236-0.681,0.496-1.021,0.751c-0.268,0.202-0.546,0.388-0.807,0.604c-0.596,0.489-1.168,1.004-1.713,1.547
		L239.542,123.179c-9.089,9.087-9.089,23.824,0,32.912c9.087,9.089,23.824,9.089,32.912,0l76.637-76.632v409.268
		c0,12.853,10.42,23.273,23.273,23.273s23.273-10.42,23.273-23.273V79.459l76.636,76.634c4.543,4.544,10.499,6.816,16.455,6.816
		c5.956,0,11.913-2.271,16.455-6.817c9.089-9.087,9.089-23.824,0-32.912L388.826,6.82C388.281,6.277,387.709,5.762,387.113,5.274z"
                                />
                              </g>
                            </svg>
                          </div>
                        </th>
                        {/* </th> */}
                        {/* <th scope="col">Recorded File</th> */}
                        <th scope="col">Recorded File</th>
                        {/* <th scope="col">Download</th> */}
                      </tr>
                    </thead>
                    <tbody
                      id="call-recording-report"
                      onScroll={(e) => handleScroll("call-recording-report")}
                    >
                      {callRecordData &&
                        callRecordData.map((item, key) => {
                          const {
                            DealerCode,
                            DealerMobileNumber,
                            FilePath,
                            ClientCode,
                            ClientMobileNumber,
                            CallRecordedDateTime,
                          } = item;

                          return (
                            <tr key="{key}">
                              <td>
                                <input
                                  type="checkbox"
                                  name="select-all"
                                  className="segmentCheckbox downloadSelect"
                                  value={FilePath}
                                  onClick={selectCheckBox}
                                />
                              </td>
                              <td>
                                {DealerCode === "" || undefined || null
                                  ? "-"
                                  : DealerCode}
                              </td>
                              <td>
                                {DealerMobileNumber === "" || undefined || null
                                  ? "-"
                                  : DealerMobileNumber}
                              </td>
                              <td>
                                {ClientCode === "" || undefined || null
                                  ? "-"
                                  : ClientCode}
                              </td>
                              <td>
                                {ClientMobileNumber === "" || undefined || null
                                  ? "-"
                                  : ClientMobileNumber}{" "}
                              </td>

                              <td>
                                {CallRecordedDateTime === "" ||
                                undefined ||
                                null
                                  ? "-"
                                  : splitDateNew(CallRecordedDateTime)}
                              </td>
                              {/* <td> */}
                              {/* {CallRecordedDateTime === "" || undefined || null
                ? "-"
                : CallRecordedDateTime} */}
                              {/* </td> */}

                              {/* <td>
              {splitDate(CreatedOn) === "" || undefined || null
                ? "-"
                : splitDate(CreatedOn)}
            </td> */}

                              <td
                                className="icon-file-download"
                                style={{ color: "#5c5cf7" }}
                                onClick={() => handleDownloadDocument(FilePath)}
                              ></td>
                            </tr>
                          );
                        })}
                      {/* {showClientRevenueData(callRecordData)} */}
                      {scrollLoader && (
                        <div className="loader-center">
                          <LoaderForSearch />
                        </div>
                      )}
                    </tbody>
                  </table>
                </div>
              </>
            ) : error !== "" ? (
              <h4 className="report-error-message">{error}</h4>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="report-error-message">{serverError}</h4>
            ) : (
              ""
            )}
          </div>
        </div>
      </main>
    </>
  );
}

export default RecordingReport;
